<template>
  <div>
    <section class="wf100 subheader mb-1 bg_header_volunteer">
      <div class="container">
        <h2>فرص التطوع</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li v-if="this.$route.params.id">المنظمة</li>
          <li>فرص التطوع</li>
        </ul>
      </div>
    </section>

    <div class="main-content general-activities">
      <!-- <main-header /> -->

      <div class="container filter_small_screen">
        <collapse-header title_img="filter" title="بحث بحسب">
          <div class="m-2">
            <div>
              <form-select
                label="مجال العمل"
                v-model="filter.position_type_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="volunteer_position"
                ep="v2/guest/selects/positions"
              />
              <form-autocomplete
                class="w-25 mx-25"
                label="المنظمة"
                :dir="'rtl'"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                v-model="filter.ngo_id"
                ep="v2/guest/filter-name"
                id="jobs_ngos_volunteer"
                filterKey="name_ar"
                placeholder="ابدأ بالكتابة للبحث"
                v-if="!this.$route.params.id"
              />
              <form-select
                label="المحافظة"
                v-model="filter.governorate_id"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="volunteer_governorate"
                ep="v2/guest/selects/governorates"
              />
              <b-form-group label="طبيعة الألتزام" class="button_radio">
                <b-form-radio-group
                  v-model="filter.employment_type"
                  :options="optionsContractWork"
                  name="radios-stacked"
                  stacked
                />
              </b-form-group>

              <div class="d-flex justify-content-between">
                <b-button variant="primary" @click="onFilterReset"
                  >إلغاء البحث</b-button
                >
                <b-button variant="info" @click="onFilterSubmitted"
                  >بحث</b-button
                >
              </div>
            </div>
            <!-- </basc-card> -->
          </div>
        </collapse-header>
      </div>

      <div class="events-listing">
        <div class="container">
          <div>
            <b-row>
              <b-col cols="3" class="min_filter">
                <div>
                  <basc-card>
                    <div>
                      <div class="d-flex align-item-center">
                        <feather-icon
                          icon="FilterIcon"
                          size="17"
                          class="mx-25"
                        />
                        <h6>بحث حسب</h6>
                      </div>
                      <hr />

                      <form-select
                        label="مجال العمل"
                        v-model="filter.position_type_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        id="volunteer_position"
                        ep="v2/guest/selects/positions"
                      />

                      <form-autocomplete
                        class="w-25 mx-25"
                        label="المنظمة"
                        :dir="'rtl'"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        v-model="filter.ngo_id"
                        ep="v2/guest/filter-name"
                        id="jobs_ngos"
                        filterKey="name_ar"
                        placeholder="ابدأ بالكتابة للبحث"
                        v-if="!$route.params.id"
                      />
                      <form-select
                        label="المحافظة"
                        v-model="filter.governorate_id"
                        :getOptionLabel="(x) => x.name_ar"
                        :reduce="(x) => x.id"
                        id="volunteer_governorate"
                        ep="v2/guest/selects/governorates"
                      />

                      <b-form-group label="طبيعة الألتزام" class="button_radio">
                        <b-form-radio-group
                          v-model="filter.employment_type"
                          :options="optionsContractWork"
                          name="radios-stacked"
                          stacked
                        />
                      </b-form-group>

                      <div class="d-flex justify-content-between">
                        <b-button
                          @click="onFilterReset"
                          style="background-color: #a21caf; color: #fff"
                          variant="#a21caf"
                          >إلغاء البحث</b-button
                        >
                        <b-button variant="info" @click="onFilterSubmitted"
                          >بحث</b-button
                        >
                      </div>
                    </div>
                  </basc-card>
                </div>
              </b-col>
              <b-col md="9" sm="12" v-if="loading" class="w-100">
                <basc-card v-for="n in 3" :key="n">
                  <b-skeleton
                    animation="fade"
                    height="22px"
                    width="25%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" width="100%"></b-skeleton>

                  <div class="d-flex justify-content-end">
                    <b-skeleton type="button"></b-skeleton>
                  </div>
                </basc-card>
              </b-col>
              <b-col md="9" sm="12" class="w-100 mt-1" v-else>
                <Job
                  v-for="item in volunteers"
                  :key="item.id"
                  :id="item.id"
                  :name="item.name"
                  :ngo_name="item.ngo_name"
                  :position_type="item.positionType.name_ar"
                  :code="item.code"
                  :closing_date="item.closing_date"
                  :governorate="item.governorate.name_ar"
                  :starting_date="item.starting_date"
                  colorV="a21caf"
                  job="volunteers"
                ></Job>

                <alert
                  v-if="volunteers.length == 0 && !loading"
                  :massage="$t('alert')"
                  class="w-100 mb-5"
                />
                <Pagination
                  v-if="pagination.total_row"
                  v-model="filter.page"
                  :total-rows="pagination.total_row"
                  :per-page="pagination.per_page"
                  align="center"
                  class="mt-2"
                >
                </Pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NotItem from "../../components/NotItem.vue";
import vSelect from "vue-select";
import Job from "../../components/Job.vue";
import BascCard from "../../components/BascCard.vue";
import CollapseHeader from "../../../../@core/components/app-collapse/CollapseHeader.vue";
import { mapGetters, mapActions } from "vuex";
import {
  BFormRadioGroup,
  BCardText,
  BFormGroup,
  BFormSelect,
  BButton,
  BSkeleton,
  BPaginationNav,
  BRow,
  BCol,
} from "bootstrap-vue";
import Alert from "../../../../components/Alert.vue";
import formAutocomplete from "@/components/form-autocomplete";
import FormSelect from "@/components/form-select";
import Pagination from "@/components/pagination/index.vue";

export default {
  components: {
    Job,
    BFormRadioGroup,
    BFormGroup,
    BFormSelect,
    NotItem,
    vSelect,
    BButton,
    BascCard,
    CollapseHeader,
    formAutocomplete,
    FormSelect,
    Alert,
    BSkeleton,
    BPaginationNav,
    Pagination,
    BRow,
    BCol,
    BCardText,
  },
  props: ["id"],
  data() {
    return {
      filter: {
        page: 1,
        ngo_id: this.id,
      },
      optionsContractWork: ["دوام كامل", "دوام جزئي", "عن بعد"],
    };
  },
  computed: {
    ...mapGetters("NgoHome/volunteer", ["volunteers", "loading", "pagination"]),
  },
  methods: {
    ...mapActions("NgoHome/volunteer", ["getVolunteers"]),
    onFilterSubmitted() {
      this.getVolunteers(this.filter);
    },
    onFilterReset() {
      this.filter = {
        page: 1,
        ngo_id: this.id,
      };
      this.getVolunteers(this.filter);
    },
  },

  watch: {
    "filter.page"() {
      this.getVolunteers(this.filter);
    },
  },

  created() {
    this.getVolunteers(this.filter);
  },
};
</script>

<style lang="scss">
.custom-radio {
  margin: 5px;
}

.button_radio {
  margin-top: 2.6rem !important;
  margin-bottom: 2.6rem !important;
}

.bg_header_volunteer {
  background: #a21caf;
}
.title {
  font-family: Almarai, sans-serif;
  font-weight: 400;
  letter-spacing: 0.00735em;
  line-height: 2.5rem;
  color: #4fc98c;
  // padding-top: 10px;
}
.filter_small_screen {
  display: none;
}
@media (max-width: 1030px) {
  .min_filter {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
</style>
